// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".auth-wrapper[data-v-0831cc1e] {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.auth-wrapper__inner[data-v-0831cc1e] {\n  margin-top: 9vh;\n}", ""]);
// Exports
module.exports = exports;
